"use client"

import { Suspense } from "react"
import { useSearchParams } from "next/navigation"

import { LoginView } from "@/features/auth/login"

import { PageProvider, useLoginContext } from "./login.context"

function LoginPageContent(): React.ReactElement {
  const { state } = useLoginContext()
  return <LoginView redirectTo={state.redirectTo} authError={state.authError} />
}

function LoginPageInner(): React.ReactElement {
  const searchParams = useSearchParams()
  const redirectTo = searchParams.get("redirect") ?? "/"
  const authError = searchParams.get("error")

  return (
    <PageProvider redirectTo={redirectTo} authError={authError}>
      <LoginPageContent />
    </PageProvider>
  )
}

export default function LoginPage(): React.ReactElement {
  return (
    <Suspense fallback={null}>
      <LoginPageInner />
    </Suspense>
  )
}
